import TariffOsagoItem from "@/views/insuranceProducts/components/ProductTariffs/TariffOsagoItem.vue"
import TariffTourismItem from "@/views/insuranceProducts/components/ProductTariffs/TariffTourismItem.vue"
import TariffGreenCardItem from "@/views/insuranceProducts/components/ProductTariffs/TariffGreenCardItem.vue"
import TariffDgoItem from "@/views/insuranceProducts/components/ProductTariffs/TariffDgoItem.vue";
import TariffHomeItem from "@/views/insuranceProducts/components/ProductTariffs/TariffHomeItem.vue";
import TariffAutLawyerItem from "@/views/insuranceProducts/components/ProductTariffs/TariffAutLawyerItem.vue";
import TariffMiniKaskoItem from "@/views/insuranceProducts/components/ProductTariffs/TariffMiniKaskoItem.vue";
import TariffPetsItem from "@/views/insuranceProducts/components/ProductTariffs/TariffPetsItem.vue";
import TariffAccidentItem from "@/views/insuranceProducts/components/ProductTariffs/TariffAccidentItem.vue";

export default {
  TariffOsagoItem,
  TariffTourismItem,
  TariffGreenCardItem,
  TariffDgoItem,
  TariffHomeItem,
  TariffAutLawyerItem,
  TariffMiniKaskoItem,
  TariffPetsItem,
  TariffAccidentItem,
}
